import React, { ReactElement } from 'react'
import styles from './SquareCheckBox.module.css'
import Text from '../text/Text'

interface ICheckBoxProps {
    checkId: string
    label?: string
    subtitle?: string
    onClick: () => void
    checked: boolean
    labelClassName?: string
    noBackground?: boolean
    children?: ReactElement
    styleContainer?: React.HTMLAttributes<HTMLDivElement>
    styleContent?: React.HTMLAttributes<HTMLDivElement>
}

export default function SquareCheckBox({
    checkId,
    label,
    subtitle,
    checked,
    onClick,
    noBackground,
    children,
    styleContainer,
    styleContent,
}: ICheckBoxProps) {
    return (
        <div className={`${styles.containerSq} ${styleContainer}`}>
            <div className={noBackground ? '' : styles.backgroundCheckboxSq}>
                <input
                    name="cssCheckboxSq"
                    id={checkId}
                    type="checkbox"
                    className={
                        checked ? styles.cssCheckboxSq : styles.noCheckedSq
                    }
                    onChange={onClick}
                    checked={checked}
                />
            </div>
            <div
                onClick={onClick}
                className={`${
                    subtitle ? styles.hasSubtitleSq : styles.noSubtitleSq
                } ${styleContent}`}
            >
                {children ? (
                    children
                ) : (
                    <>
                        <Text
                            label={label ? label : ''}
                            variant={`Subtitle2 ${styles.textStyleSq}`}
                        />
                        {subtitle && (
                            <Text
                                label={subtitle}
                                variant={`Small-2 ${styles.subtitleTextStyleSq}`}
                                marginTop={10}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    )
}
